var _path, _path2, _path3, _path4, _path5;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgGasOil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.9165 18.3332V4.1665C2.9165 2.49984 4.03317 1.6665 5.4165 1.6665H12.0832C13.4665 1.6665 14.5832 2.49984 14.5832 4.1665V18.3332H2.9165Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.6665 18.3335H15.8332",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9915 8.3332H10.5165C11.3832 8.3332 12.0915 7.91653 12.0915 6.7582V5.7332C12.0915 4.57487 11.3832 4.1582 10.5165 4.1582H6.9915C6.12484 4.1582 5.4165 4.57487 5.4165 5.7332V6.7582C5.4165 7.91653 6.12484 8.3332 6.9915 8.3332Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.4165 10.8335H7.9165",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5835 13.3417L18.3335 13.3333V8.33333L16.6668 7.5",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGasOil);
export default __webpack_public_path__ + "static/media/gas_oil.6a320544.svg";
export { ForwardRef as ReactComponent };